(function () {
    'use strict';

    var module = angular.module('uwAgenda.login');
    module.directive('passwordIdentical', [PasswordIdenticalFn]);

    function PasswordIdenticalFn() {

        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A',
            scope: {
                toproof: '='
            }
        };
        return directive;

        function link(scope, element, attrs, mCtrl) {
            // are password identical ?
            mCtrl.$validators.passwordIdentical = function (value) {
                return value === scope.toproof;
            };

            // when ngModel of password-input changes
            var watchUnbinder = scope.$watch('toproof', function (newVal) {
                mCtrl.$validate();
            }, true);

            // on destroy
            scope.$on('$destroy', function () {
                watchUnbinder();
                watchUnbinder = null;
            });
        }
    }

})();